<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">POS Pedidos</h5>
        <div class="row col-12" style="flex-direction: row-reverse">
          <div class="col-2">
            <input
              class="form-control form-control-sm rounded bright"
              placeholder="Search"
              v-model="searchtext"
              type="text"
              v-on:keyup.enter="filterData()"
            />
          </div>
          <div class="col-2">
            <input
              class="form-control form-control-sm rounded bright"
              placeholder="# Pedido"
              v-model="search.numero"
              type="text"
              v-on:keyup.enter="filterData()"
            />
          </div>
          <div class="col-2">
            <input
              class="form-control form-control-sm rounded bright"
              placeholder="Nit cliente"
              v-model="search.cliente"
              type="text"
              v-on:keyup.enter="filterData()"
            />
          </div>
          <div class="col-2">
            <select
              class="form-control form-control-sm rounded bright"
              v-model="filtro_tienda"
              @change="refreshCajas()"
            >
              <option value="">Tiendas</option>
              <option v-for="data in tiendas" :value="data.codigo" v-bind:key="data.id">
                {{ data.nombre }}
              </option>
            </select>
          </div>
        </div>
        <NuevoPedidoModalComponent />
        <div class="row col-12 controls-above-table" style="justify-content: flex-end">
          <div class="col-2">
            <input
              type="date"
              v-model="search.fecha"
              class="form-control form-control-sm rounded bright"
            />
          </div>
          <div class="col-2">
            <select
              class="form-control form-control-sm rounded bright"
              v-model="filtro_caja"
              @change="filterData()"
            >
              <option value="">cajas</option>
              <option v-for="data in cajas" :value="data.id" v-bind:key="data.id">
                {{ data.caja }}
              </option>
            </select>
          </div>
          <div class="col-2">
            <select
              class="form-control form-control-sm rounded bright"
              v-model="filtro_estado"
              @change="filterData()"
            >
              <option value>ESTATUS</option>
              <option value="9">ANULADO</option>
              <option value="A">ABIERTO</option>
              <option value="B">CERRADO</option>
              <option value="E">IMPRESA</option>
              <option value="I">PICKING</option>
            </select>
          </div>
          <div class="input-group-append col-2">
            <button
              class="btn btn-link btn-sm"
              type="button"
              v-on:click="filterData()"
              style="width: 55px"
            >
              <i class="fa fa-search"></i>
              Buscar
            </button>
            <button
              class="btn btn-link btn-sm"
              type="button"
              v-on:click="clearFilterData"
              style="width: 30px"
            >
              <i class="fa fa-times"></i>
              Limpiar Datos
            </button>
          </div>
        </div>
        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Numero</th>
                <th>Fecha</th>
                <th>Tienda</th>
                <th>Caja</th>
                <th>Vendedor</th>
                <th>Cliente</th>
                <th class="text-center">Estado</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="current in data.results"
                v-bind:key="current.id"
                @click="rowClick(current)"
              >
                <td class="text-center">{{ current.numero }}</td>
                <td>{{ current.fecha }}</td>
                <td>{{ current.tienda.nombre }}</td>
                <td>{{ current.caja.caja }}</td>
                <td>
                  <UsuarioEnTablaComponent :current="current.vendedor" />
                </td>
                <td v-if="current.cliente">
                  ({{ current.cliente.nit }}) {{ current.cliente.nombre }}
                </td>
                <td v-if="!current.cliente"></td>
                <td class="text-center">
                  {{ current.estado_str }}
                </td>
                <td class="text-right">Q {{ current.total }}</td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent
          :currentPage="currentPage"
          :data="data"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import PedidosServices from "@/services/pos/PedidosServices";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import NuevoPedidoModalComponent from "@/components/pos/NuevoPedidoModalComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
    NuevoPedidoModalComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActivo: "",
      data: [],
      search: {},
      filtro_tienda: "",
      tiendas: "",
      filtro_estado: "",
      filtro_caja: "",
      cajas: "",
    };
  },
  mounted() {
    this.refreshData();
    this.refreshTienda();
  },
  methods: {
    convertFormatDate(search) {
      search.fecha_creacion = moment(search.fecha).format("DD/MM/YYYY");
    },
    refreshCajas() {
      let self = this;
      this.filtro_caja = "";
      DynamicService.fetch("cxc", "caja", {
        tienda: this.filtro_tienda,
      }).then((response) => {
        self.cajas = response.data.results;
        this.filterData();
      });
    },
    refreshTienda() {
      let self = this;
      DynamicService.fetch("cat", "tiendas", {
        activa: true,
        quitar_paginacion: true,
      }).then((response) => {
        self.tiendas = response.data;
      });
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "pos-pedidos-ver",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "pos-pedidos-ver",
          params: { id: current.id },
        });
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: page,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        tienda: this.filtro_tienda,
        caja: this.filtro_caja,
        cargo_serie: this.search.cargo_serie,
        cliente: this.search.cliente,
        numero: this.search.numero,
        fecha: this.search.fecha_creacion,
      });
    },
    filterData() {
      if (this.search.fecha) {
        this.convertFormatDate(this.search);
      }
      this.refreshData({
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        caja: this.filtro_caja,
        tienda: this.filtro_tienda,
        cargo_serie: this.search.cargo_serie,
        cliente: this.search.cliente,
        numero: this.search.numero,
        fecha: this.search.fecha_creacion,
      });
    },
    filterDataSubmit(e) {
      this.filterData();
      e.preventDefault();
    },
    clearFilterData() {
      this.filtro_tienda = "";
      this.filtro_estado = "";
      this.filtro_caja = "";
      this.search = {
        cargo_serie: "",
        cliente: "",
        numero: "",
        fecha: "",
      };
      this.$data.currentPage = 1;
      this.filterData();
    },
    hide: function () {
      this.$data.destroy();
    },
    refreshData(params) {
      let self = this;
      PedidosServices.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    showModalEdit() {},
  },
};
</script>
